import React, { useEffect, useState } from 'react'
import { Col, Radio, Row } from 'antd'
import { CiCircleCheck } from "react-icons/ci";
import { FaRegCircle } from "react-icons/fa";
import Button from '../../../../components/FormElements/Button';
import Poll from './Poll';
import Post from './Post';

const AddEditPost = ({ closeAddEditPostModal, refreshFeed, editData }) => {
    const [selectedPostType, setSelectedPostType] = useState('post')

    const postTypes = ['post', 'poll']

    const handleModeChange = (e) => {
        setSelectedPostType(postTypes.filter(v => v === e.target.value)[0])
    };

    const submitForm = () => {
        document.querySelector(
            selectedPostType.toLowerCase().includes('post') ? 'form#postForm' : 'form#pollForm')?.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }))
    }

    const closeAddEditPost = () => {
        closeAddEditPostModal()
    }

    useEffect(() => {
        if(editData && editData?.type){
            setSelectedPostType(editData?.type)
        }
    }, [editData])
    

    return (
        <Row>
            <Col md={24} sm={24} xs={24} className='flex justify-center mb-2 mt-2'>
                <h5 className='heading-5 font-bold'>
                    {`${editData ? 'Edit' : 'Create'} ${selectedPostType.slice(0,1).toUpperCase() + selectedPostType.slice(1)}` }
                </h5>
            </Col>
            { !editData && (
            <Col md={24} sm={24} xs={24} className='flex justify-center mb-2'>
                <Radio.Group
                    onChange={handleModeChange}
                    value={selectedPostType}
                    style={{ marginBottom: 8 }}
                >
                    {postTypes.map(item => (
                        <Radio.Button
                            key={item}
                            value={item}
                            className={item == selectedPostType && "selected-tab"}
                        >
                            <div className="flex justify-between items-center">
                                {item == selectedPostType ? (
                                    <CiCircleCheck className="text-black bg-primary rounded-full" />
                                ) :
                                    <FaRegCircle />
                                }
                                <span className="ml-2">
                                    {item == 'post' ? 'Post' : 'Poll'}
                                </span>
                            </div>
                        </Radio.Button>
                    ))}
                </Radio.Group>
            </Col>
            )}
            <Col md={24} sm={24} xs={24} className='flex flex-col justify-center'>
                {   selectedPostType == 'post' ? 
                    <Post closeAddPost={closeAddEditPost} refreshFeed={refreshFeed} editData={editData?.data} /> : 
                    <Poll closeAddPost={closeAddEditPost} refreshFeed={refreshFeed} editData={editData?.data} /> 
                }
                <div className="flex justify-start w-full mt-2 mb-6">
                    <Button.Basic
                        onClick={submitForm}
                        disabled={false}
                        icon={null}
                        loading={false}
                        type="primary"
                        size='medium'
                        text='Submit'
                        className='btn-primary w-full'
                    />
                </div>
            </Col>
        </Row>
    )
}

export default AddEditPost